// extracted by mini-css-extract-plugin
export default {"bg":"Admin_bg__F-5dy","card":"Admin_card__bpV+F","menu-container":"Admin_menu-container__g28MD","menu":"Admin_menu__sr9bW","btn5":"Admin_btn5__yrNZ4"};